import "./VideoHome.scss";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

function VideoHome() {
  const videoEl = useRef(null);

  const attemptPlay = () => {
    videoEl &&
      videoEl.current &&
      videoEl.current.play().catch(error => {
        console.error("Error attempting to play", error);
      });
  };
  
  const { t } = useTranslation();

  const heroGraphic = t("heroGraphic");

  useEffect(() => {
    attemptPlay();
  }, []);

  return (
    <section className="video-home">
      <div className="video-home__container">
        { heroGraphic && heroGraphic.indexOf('.mp4') !== -1 ?
          (  <video playsInline
              loop
              muted
              autoPlay
              alt="Hero home video de Bookolicos"
              src={heroGraphic}
              ref={videoEl}
              className="video-home__video" />
          ) : null }
          
          { heroGraphic && (heroGraphic.indexOf('.png') !== -1 || heroGraphic.indexOf('.jpg') !== -1) ?
          (  <img
              alt="Hero home image de Bookolicos"
              src={heroGraphic}
              className="video-home__img" />
          ) : null }
      </div>
    </section>
  );
}

export default VideoHome;
